import { require200Status } from "../../utils/response.js";
import { parseQs } from "../../../utils/qs.js";
import { transformWithSpec } from "../../../utils/response.js";
function publicGamesEndpoints(builder) {
  return {
    getPublicGameList: builder.query({
      providesTags: ["games"],
      query: ({ query }) => ({
        url: `/game/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameProviderList: builder.query({
      providesTags: ["game-providers"],
      query: ({ query }) => ({
        url: `/game/providers${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameProviderStats: builder.query({
      providesTags: ["game-providers"],
      query: () => ({
        url: `/game/stats`,
        method: "GET",
        validateStatus: require200Status
      }),
      transformResponse: transformWithSpec()
    }),
    getPublicGameCategoryList: builder.query({
      providesTags: ["game-categories"],
      query: ({ query }) => ({
        url: `/category/list${parseQs(query)}`,
        method: "GET"
      }),
      transformResponse: transformWithSpec()
    })
  };
}
export {
  publicGamesEndpoints as default
};
